/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RolePermissionDto } from '../models/RolePermissionDto';
import type { UnitDto } from '../models/UnitDto';
import type { UserModel } from '../models/UserModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { MyTaskType } from '../models/MyTaskType';
import { MyTaskDto } from '../models/MyTaskDto';
import { ViewProcessCommentDto } from '../models/ViewProcessCommentDto';
import { DocumentIdAngLanguageCodeDto } from '../models/DocumentIdAngLanguageCodeDto';
import { DocumentUsedDto } from '../models/DocumentUsedDto';

export class UserService {

  /**
   * @returns UserModel Success
   * @throws ApiError
   */
  public static readUser(): CancelablePromise<UserModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/User/current',
    });
  }

  /**
   * @param unitId 
   * @param processId 
   * @returns RolePermissionDto Success
   * @throws ApiError
   */
  public static readUserPermissions(
unitId?: number,
processId?: number,
): CancelablePromise<Array<RolePermissionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/User/permissions',
      query: {
        'unitId': unitId,
        'processId': processId,
      },
    });
  }

   public static markAsFavorite(
      requestBody?: DocumentIdAngLanguageCodeDto
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/User/markAsFavorite',
        body: requestBody
      });
    }
  
     public static unMarkAsFavorite(
      requestBody?: DocumentIdAngLanguageCodeDto
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/User/unMarkAsFavorite',
        body: requestBody
      });
    }


      /**
       * @param unitId
       * @returns DocumentUsedDto Success
       * @throws ApiError
       */
      public static getApiUserFavoriteDocuments(unitId: number): CancelablePromise<Array<DocumentUsedDto>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/User/favoriteDocuments/{unitId}',
          path: {
            unitId: unitId
          }
        });
      }


  /**
     * @param id
     * @returns ViewProcessCommentDto Success
     * @throws ApiError
     */
    public static getApiUserCommentsInUnit(id: number): CancelablePromise<Array<ViewProcessCommentDto>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/user/{id}/comments',
        path: {
          id: id
        }
      });
    }

   /**
   * @param myTaskType 
   * @returns MyTaskDto[] Success
   * @throws ApiError
   */
   public static getApiMyTasks(type: MyTaskType): CancelablePromise<MyTaskDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/User/myTasks/{type}',
      path: {
        type: type
      }
    });
  }

  /** 
   * @returns boolean Success
   * @throws ApiError
   */
   public static getUserHasAccessToAdditionalTabs(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/User/myTasks/additionalTabs',
    });
  }

  /**
   * @returns number Success
   * @throws ApiError
   */
  public static getApiMyTasksCount(): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/User/myTasks/count',
    });
  }

  /**
   * @returns UnitDto Success
   * @throws ApiError
   */
  public static readUserIsPortalOwner(): CancelablePromise<Array<UnitDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/User/units',
    });
  }

}
